import { Button } from '@fluentui/react-components';
import { FooterWrapper } from './TicketDetailsFooter.styled';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const TicketDetailsFooter = () => {
  const { toggleTicketDetails } = useServiceDeskContext();
  return (
    <FooterWrapper>
      <Button onClick={() => toggleTicketDetails('', '', false)}>Done</Button>
    </FooterWrapper>
  );
};
